export default "__VITE_ASSET__Bcwhkw8W__"